import type { JSX } from 'react';
import { Stack, Typography } from '@mui/material';

import { useAuth } from '../auth/AuthProvider';
import { CompanySelectionScreen } from '../tenancy/CompanySelectionScreen';

export function CompanySelectionPage(): JSX.Element {
  const auth = useAuth();

  return (
    <Stack spacing={2.5}>
      <Typography variant="h4">
        {auth.canAccessPlatform ? 'Select workspace' : 'Select company'}
      </Typography>
      <CompanySelectionScreen />
    </Stack>
  );
}
